{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Πρότυπα Whatsapp",
      "SUBTITLE": "Επιλέξτε το πρότυπο Whatsapp που θέλετε να στείλετε",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Αναζήτηση Προτύπων",
      "NO_TEMPLATES_FOUND": "Δεν βρέθηκαν πρότυπα για",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Κατηγορία",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Γλώσσα",
        "TEMPLATE_BODY": "Σώμα Προτύπου",
        "CATEGORY": "Κατηγορία"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Μεταβλητές",
      "LANGUAGE": "Γλώσσα",
      "CATEGORY": "Κατηγορία",
      "VARIABLE_PLACEHOLDER": "Εισάγετε τιμή για {variable}",
      "GO_BACK_LABEL": "Πίσω",
      "SEND_MESSAGE_LABEL": "Αποστολή μηνύματος",
      "FORM_ERROR_MESSAGE": "Παρακαλώ συμπληρώστε όλες τις μεταβλητές πριν την αποστολή",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
